import { HOLDING_REPORT, FILTER_DATA, SORT_DATA, SUMMARIZE, SEARCH, QUANTITY_BREAKDOWN, SCREENSTATE, SELECTED_STOCK, HOLDING_DATA_FLAGS, } from "@frameworks/web/redux/interfaces/Reports/CoreReports/iHolding";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { ESortOrder } from "@domains/utils/sort";
import { EREPORTSCREENSTATE } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
const initHoldingReport = {
    holdings: {
        HoldingDetails: [],
        HoldingSummary: {
            date: "",
            message: "",
            totalInvestment: "0",
            currentValue: "0",
            totalPnL: "0",
            daysPnL: "0",
            totalPnLChange: "0",
            daysPnLChange: "0",
        },
    },
    sortData: {
        sortState: [],
        sortRecord: {
            title: "",
            key: "",
            order: ESortOrder.ASC,
            orderText: {
                asc: "",
                desc: "",
            },
        },
        data: [],
    },
    filterData: {
        simpleFilter: {
            name: "",
            filters: [],
        },
        assetFilter: {
            name: "",
            filters: [],
        },
    },
    summarize: false,
    search: "",
    quantityBreakDown: false,
    screenState: EREPORTSCREENSTATE.L1,
    selectedStock: undefined,
    goBackState: false,
    HoldingDataFlags: {
        isOmneOnly: false,
        bodProcessInfoMessage: "",
        isBodEnabled: false
    }
};
const HoldingReducer = (state = initHoldingReport, action) => {
    switch (action.type) {
        case HOLDING_REPORT:
            return Object.assign(Object.assign({}, state), { holdings: action.payload.holdings });
        case HOLDING_DATA_FLAGS:
            return Object.assign(Object.assign({}, state), { HoldingDataFlags: action.payload.HoldingDataFlags });
        case FILTER_DATA:
            return Object.assign(Object.assign({}, state), { filterData: action.payload.filterData });
        case SORT_DATA:
            return Object.assign(Object.assign({}, state), { sortData: action.payload.sortData });
        case SUMMARIZE:
            return Object.assign(Object.assign({}, state), { summarize: action.payload.summarize });
        case SEARCH:
            return Object.assign(Object.assign({}, state), { search: action.payload.search });
        case QUANTITY_BREAKDOWN:
            return Object.assign(Object.assign({}, state), { quantityBreakDown: action.payload.quantityBreakDown });
        case SCREENSTATE:
            return Object.assign(Object.assign({}, state), { screenState: action.payload.screenState, goBackState: action.payload.goBackState });
        case SELECTED_STOCK:
            return Object.assign(Object.assign({}, state), { selectedStock: action.payload.selectedStock });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: HoldingReducer,
    commonData: commonOnePlatFormReducer,
});
